export { default as CookiesBar } from './cookies-bar'